import { Heading } from '@instabox/consumer-web-ui'
import cn from 'classnames'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { FC, ReactNode } from 'react'

import { ENV_CONFIG } from '../../../constants/envConfig'
import { CategoryWithFaqs } from '../../../types'
import styles from './categoryTitle.module.scss'
import { styleToIcon } from './constants'

export interface CategoryTitleProps {
  icon: CategoryWithFaqs['icon']
  slug: CategoryWithFaqs['slug']
  children?: ReactNode | undefined
}

const CategoryTitle: FC<CategoryTitleProps> = ({ icon, slug, children }) => {
  const Wrapper = ({ children }) =>
    slug ? (
      <Link href={`/help/category/${slug}`} className="no-underline">
        {children}
      </Link>
    ) : (
      <>{children}</>
    )

  return (
    <Wrapper>
      <Heading as="h6" className={cn(styles.title, 'mb-4')}>
        <span className={cn(styles.icon, 'mr-3')}>
          {icon && (
            <Image
              src={`${ENV_CONFIG.DIRECTUS_URL}/assets/${icon.id}`}
              alt={icon.title}
              width={icon.width || 28}
              height={icon.height || 28}
              objectFit={icon.title === 'Delivery' ? 'cover' : 'fill'}
              style={{ ...styleToIcon[icon.title] }}
            />
          )}
        </span>
        <span>{children}</span>
      </Heading>
    </Wrapper>
  )
}

export default CategoryTitle
